import Section from './Section.jsx';

const BEACH_LABELS = {
  folly: 'Folly Beach',
  iop: 'Isle of Palms',
  sullivans: "Sullivan's Island",
  kiawah: 'Kiawah / Beachwalker'
};

const FLAG_STYLES = {
  green: 'bg-marsh-500',
  yellow: 'bg-cream-500',
  red: 'bg-charlestonpink-500',
  purple: 'bg-charlestonpink-600',
  unknown: 'bg-navy-300'
};

export default function BeachConditions({ beachNotes }) {
  if (!beachNotes) return null;
  const beaches = Object.keys(BEACH_LABELS).filter((id) => beachNotes[id]);
  return (
    <Section id="beach" title="Beach conditions" eyebrow="By the water">
      <div className="space-y-3">
        {beaches.map((id) => {
          const flag = beachNotes.flags?.[id]?.flag || 'unknown';
          const flagNote = beachNotes.flags?.[id]?.note;
          return (
            <div
              key={id}
              // Plain information sits on cream-100 with no border, the dining
              // card's surface; white is for inputs only (DECISIONS 2026-09-20).
              className="rounded-lg bg-cream-100 px-4 py-3"
            >
              <div className="mb-1 flex items-center gap-2">
                <span
                  className={['inline-block h-2.5 w-2.5 rounded-full', FLAG_STYLES[flag]].join(' ')}
                  aria-label={`${flag} flag`}
                />
                <h3 className="font-display text-base font-semibold text-navy-900">
                  {BEACH_LABELS[id]}
                </h3>
                {flagNote && (
                  <span className="text-xs text-navy-500">· {flagNote}</span>
                )}
              </div>
              <p className="text-sm leading-relaxed text-navy-700">{beachNotes[id]}</p>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
